import { EventEmitter, Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WestnetzSidenavService {

    private openRightNav = new EventEmitter<Type<any>>();
    private closeRightNav = new EventEmitter<void>();

    constructor() {
    }

    public get openRightNav$(): Observable<Type<any>> {
        return this.openRightNav;
    }

    public get closeRightNav$(): Observable<void> {
        return this.closeRightNav;
    }

}
